import React from "react";
import { Button } from "../../../../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../../ui/dialog";
import { 
  RocketIcon,
  AlertCircleIcon,
} from "lucide-react";

interface LoadedTreeMetadata {
  id: number;
  conversation_flow_name: string;
  application_name: string;
  intent_name: string;
  conversation_flow_version: number;
  is_latest: boolean;
  status?: string;
}

interface FinetuneConfirmationModalProps {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loadedTreeMetadata?: LoadedTreeMetadata | null;
}

const FinetuneConfirmationModal: React.FC<FinetuneConfirmationModalProps> = ({
  isVisible,
  onClose,
  onConfirm,
  loadedTreeMetadata,
}) => {
  return (
    <Dialog open={isVisible} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-background border-border shadow-xl ring-1 ring-border/20 backdrop-blur-sm" style={{ zIndex: 9999 }}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <RocketIcon className="w-5 h-5 text-maitai-green" />
            Trigger Finetune
          </DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <div className="p-3 border border-border bg-accent/20 rounded-md flex items-start gap-2">
            <AlertCircleIcon className="h-4 w-4 text-muted-foreground flex-shrink-0 mt-0.5" />
            <div>
              <strong>About to start finetune process</strong>
              <div className="mt-2">
                <p className="text-sm">This will:</p>
                <ul className="text-sm list-disc list-inside mt-1 space-y-1">
                  <li>Save your current conversation tree (with validation)</li>
                  <li>Generate training datasets from conversation paths</li>
                  <li>Create test sets for evaluation</li>
                  <li>Start a finetune run using your tree data</li>
                </ul>
              </div>
            </div>
          </div>
          
          {loadedTreeMetadata && (
            <div className="mt-4 p-3 bg-accent/10 border border-border rounded-md">
              <p className="font-gc-med text-sm">Tree Details:</p>
              <div className="mt-1 text-xs text-muted-foreground space-y-1">
                <div><strong>Name:</strong> {loadedTreeMetadata.conversation_flow_name}</div>
                <div><strong>Version:</strong> v{loadedTreeMetadata.conversation_flow_version}</div>
                <div><strong>Application:</strong> {loadedTreeMetadata.application_name}</div>
                <div><strong>Intent:</strong> {loadedTreeMetadata.intent_name}</div>
              </div>
            </div>
          )}
        </div>
        
        <DialogFooter>
          <Button onClick={onClose} className="h-6 px-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground">
            Cancel
          </Button>
          <Button 
            onClick={onConfirm}
            className="h-6 px-2 bg-foreground hover:bg-foreground/90 text-background"
          >
            Start Finetune
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FinetuneConfirmationModal;